
import React, { useState, useEffect } from "react";
import { Form, InputNumber, Button, Card, Typography, Row, Col } from "antd";
import { useCurrency } from "../../global/CurrencyContext";
const { Title, Text } = Typography;


const BondRepaymentCalculator = ()=>{

   const [monthlyRepayment, setMonthlyRepayment] = useState(null);

   const formatNumber = (value) => {
    if (!value) return "";
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  };

  const parseNumber = (value) => {
    return value ? value.replace(/\s/g, "") : "";
  };

  const calculateRepayment = (values) => {
    const { propertyPrice, deposit, interestRate, loanTerm } = values;
    
    const P = propertyPrice - deposit; // Principal loan amount
    const r = interestRate / 100 / 12; // Monthly interest rate
    const n = loanTerm * 12; // Total number of months

    if (P > 0 && r > 0 && n > 0) {
      const M = (P * r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);
      setMonthlyRepayment(formatNumber(M.toFixed(2)));
    } else {
      setMonthlyRepayment(null);
    }
  };

 
const [country, setCountry] = useState("");
const [currency, setCurrency] = useState("$");


  useEffect(() => {
      fetch("https://ipapi.co/json/")
        .then((res) => res.json())
        .then((data) => {
          const countryCode = data.country_code; // e.g., ZA, US
          setCurrency(getCurrencyCode(countryCode));
        })
        .catch((err) => {
          console.error("Error fetching currency:", err);
          setCurrency("$"); // Fallback
        });
    }, []);
  
    const getCurrencyCode = (countryCode) => {
      const currencyMap = {
        ZA: "R",   // South Africa
        US: "$",   // United States
        GB: "£",   // United Kingdom
        NG: "₦",   // Nigeria
        KE: "KES", // Kenya
        IN: "₹",   // India
      };
      return currencyMap[countryCode] || "$";
    };


  return (
    <Card title="Bond Repayment Calculator" style={{ maxWidth: 800, margin: "auto", marginTop: 20 }}>
      <Row gutter={24}>
        <Col span={14}>
          <Form layout="vertical" onFinish={calculateRepayment} initialValues={{ propertyPrice: 300000, deposit: 0, interestRate: 11, loanTerm: 20 }}>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label={"Property Price ("+currency+")"} name="propertyPrice" rules={[{ required: true, message: "Please enter the property price" }]}> 
                  <InputNumber style={{ width: "100%" }} min={1} step={10000} formatter={formatNumber} parser={parseNumber} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label={"Initial Deposit ("+currency+")"} name="deposit" rules={[{ required: true, message: "Please enter the initial deposit" }]}> 
                  <InputNumber style={{ width: "100%" }} min={0} step={10000} formatter={formatNumber} parser={parseNumber} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Annual Interest Rate (%)" name="interestRate" rules={[{ required: true, message: "Please enter the interest rate" }]}> 
                  <InputNumber style={{ width: "100%" }} min={0.1} step={0.1} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Loan Term (Years)" name="loanTerm" rules={[{ required: true, message: "Please enter the loan term" }]}> 
                  <InputNumber style={{ width: "100%" }} min={1} max={30} step={1} />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item>
              <Button type="primary" htmlType="submit" block>
                Calculate Repayment
              </Button>
            </Form.Item>
          </Form>
        </Col>
        <Col span={10}>
          {monthlyRepayment !== null && (
            <Card style={{ textAlign: "center" }}>
              <Title level={4}>Monthly Repayment</Title>
              <Text strong style={{ fontSize: "18px" }}>
                {currency} {monthlyRepayment}
              </Text>
            </Card>
          )}
        </Col>
      </Row>
    </Card>
  );
}



export default BondRepaymentCalculator;